export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyCxNg9vWc_AXCgTiJkiMlft9ruPpObnpP4",
        authDomain: "primarschule-hirzbrunnen-z5p0s.firebaseapp.com",
        databaseURL: "https://primarschule-hirzbrunnen-z5p0s.firebaseio.com",
        projectId: "primarschule-hirzbrunnen-z5p0s",
        storageBucket: "primarschule-hirzbrunnen-z5p0s.firebasestorage.app",
        messagingSenderId: "431422339215",
        appId: "1:431422339215:web:c5428a605bc8f1981b58fa",
        measurementId: "G-37DBGZG5BE"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts